/**
 * Report notes — the doctor's free-text record of reports a patient produced without leaving a
 * hard copy, e.g. "Seen past CBC, all values normal except RBC which is low". Stored against the
 * patient rather than the prescription so any doctor seeing them later can refer back. Never
 * printed on the prescription.
 *
 * Shared between the prescription writer's rail modal (where they're created and edited) and the
 * patient profile's Report Notes tab (where they're reviewed). Lives in utils rather than either
 * component because PrescriptionManagement already imports from PatientManagement, so putting it
 * in PatientManagement would close an import cycle.
 */
export const REPORT_NOTE_CATEGORIES = [
  { key: 'LAB', label: 'Lab report', pill: 'bg-blue-100 text-blue-700' },
  { key: 'RADIOLOGY', label: 'Radiology report', pill: 'bg-violet-100 text-violet-700' },
  { key: 'GENERAL', label: 'General', pill: 'bg-gray-100 text-gray-700' },
];

/** Category metadata for a stored key, falling back to GENERAL for unknown/legacy values. */
export const reportNoteCategory = (key) =>
  REPORT_NOTE_CATEGORIES.find((c) => c.key === key) || REPORT_NOTE_CATEGORIES[2];
